import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1602b7d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex h-full w-full items-center justify-center" }
const _hoisted_2 = { class: "flex flex-col justify-between" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "loge",
  src: "https://djcps.oss-cn-hangzhou.aliyuncs.com/pro/djmes/login-client.png"
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "time ml-6 w-56 text-white font-medium" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "wifiicon" }
const _hoisted_8 = {
  class: "flex text-sm items-center justify-center rou",
  style: {"flex-grow":"2"}
}
const _hoisted_9 = {
  class: "felx flex items-center justify-end pr-4",
  style: {"flex-grow":"1"}
}
const _hoisted_10 = { class: "machineName text-white font-medium" }
const _hoisted_11 = {
  key: 0,
  class: "line"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_JIcon = _resolveComponent("JIcon")!
  const _component_jtabBar = _resolveComponent("jtabBar")!
  const _component_title1 = _resolveComponent("title1")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "loege-box",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.refresh && _ctx.refresh(...args)))
      }, _hoisted_4),
      _createElementVNode("div", {
        class: "flex items-center loge-time",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showButtom && _ctx.showButtom(...args)))
      }, [
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.dataTime), 1),
        _createElementVNode("img", {
          class: "wifiicon",
          src: _ctx.WIFIStatu === 'best' ? 'https://djcps.oss-cn-hangzhou.aliyuncs.com/pro/djmes/wifi3.png' : _ctx.WIFIStatu === 'normal' ? 'https://djcps.oss-cn-hangzhou.aliyuncs.com/pro/djmes/wifi2.png' : 'https://djcps.oss-cn-hangzhou.aliyuncs.com/pro/djmes/wifi0.png'
        }, null, 8, _hoisted_6),
        _createElementVNode("span", _hoisted_7, [
          _createVNode(_component_JIcon, {
            icon: !_ctx.statu ? 'mes-shebei' : '',
            size: _ctx.$px2rem('30px'),
            style: {"color":"red"}
          }, null, 8, ["icon", "size"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_jtabBar, {
        tagsData: _ctx.tagsTag,
        onSwitchTags: _ctx.switchRadio,
        "default-tag": _ctx.defaultTag,
        value: _ctx.rValue
      }, null, 8, ["tagsData", "onSwitchTags", "default-tag", "value"])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_a_dropdown, {
          trigger: ['click'],
          getPopupContainer: (triggerNode) => triggerNode.parentNode
        }, {
          overlay: _withCtx(() => [
            _createVNode(_component_a_menu, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_menu_item, {
                  key: "0",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeMT('Machine')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 切换机台 ")
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_menu_item, {
                  key: "1",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.changeMT('team')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 切换班组 ")
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_menu_item, {
                  key: "2",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.changeMT('logout')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" 退出 ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", {
              onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"])),
              class: "flex items-center justify-end"
            }, [
              _createVNode(_component_title1, {
                title: '机台',
                text: _ctx.machineName,
                widthNum: 16
              }, null, 8, ["text"]),
              (_ctx.machineName && _ctx.teamName)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11))
                : _createCommentVNode("", true),
              _createVNode(_component_title1, {
                title: '班组',
                text: _ctx.teamName,
                widthNum: 10
              }, null, 8, ["text"]),
              _createVNode(_component_JIcon, {
                icon: "mes-shezhi",
                size: _ctx.$px2rem('35px'),
                style: _normalizeStyle({ marginLeft: _ctx.$px2rem('27px'), cursor: 'pointer', })
              }, null, 8, ["size", "style"])
            ])
          ]),
          _: 1
        }, 8, ["getPopupContainer"])
      ])
    ])
  ]))
}